import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { WebinarCallToActionInterface } from 'common/types/entities/WebinarCallToActionInterface'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { generateId } from 'src/shared/entities/utils/generate-base-entity'

export function createWebinarCallToAction(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): WebinarCallToActionInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.WebinarCallToAction,
      parentId,
      masterBlockId,
    ),
    text: '',
    textFontSize: 20,
    subTextFontSize: 16,
    lineHeight: 27,
    textColor: 'rgba(255, 255, 255, 1)',
    subTextColor: 'rgba(255,255,255,0.8)',
    background: 'rgba(1, 116, 199, 1)',
    hover: {
      textColor: 'rgba(255, 255, 255, 1)',
      backgroundColor: 'rgba(1, 116, 199, 1)',
    },
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2)',
    mobileBoxShadow: 'none',
    width: 'auto',
    mobileWidth: '100%',
    alignSelf: 'center',
    border: {
      width: 1,
      style: BorderStyleEnum.none,
      radius: {
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
        borderBottomLeftRadius: 5,
      },
      type: BorderTypeEnum.fullBorder,
    },
    margin: { marginTop: 25, marginRight: 0, marginBottom: 0, marginLeft: 0 },
    padding: {
      paddingTop: 9,
      paddingRight: 25,
      paddingBottom: 9,
      paddingLeft: 25,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    childIds: [],
  }
}
